/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 5/13/21
 * Copyright All Rights Reserved
 */
import { getOr, keyBy } from 'lodash/fp';
import { FETCH_INVENTORIES_RESPONSE, FETCH_INVENTORY_RESPONSE } from 'constants/actionTypes';

const defaultState = {};

const byId = (state = defaultState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case FETCH_INVENTORIES_RESPONSE:
      if (error) {
        return state;
      }
      return payload.reduce((acc, inventory) => {
        const inventoryId = inventory.uuid;
        const current = state[inventoryId];
        return (
          current
            ? acc
            : {
              ...acc,
              [inventoryId]: inventory,
            }
        );
      }, state);
    case FETCH_INVENTORY_RESPONSE: {
      if (error) {
        return state;
      }
      const current = state[payload.uuid];
      const currentModelResults = getOr({}, 'modelResults', current);
      const currentPortfolioResults = getOr({}, 'portfolioResults', current);

      return {
        ...state,
        [payload.uuid]: {
          ...payload,
          modelResults: {
            ...currentModelResults,
            ...keyBy('uuid', payload.modelResults),
          },
          portfolioResults: {
            ...currentPortfolioResults,
            ...keyBy('uuid', payload.portfolioResults),
          },
        },
      };
    }
    default:
      return state;
  }
};

export default byId;



// WEBPACK FOOTER //
// ./js/reducers/entities/inventories/byId.js